let Utils = (window.Utils = {});

const CONTINUE = '__CONTINUE__';
const BREAK = '__BREAK__';
const EXPANDO = '__DATA__';

(function () {
  var utils = this;

  var CONSTS = {};
  var RE = {
    EMAIL: /^([a-zA-Z0-9_\-\.\+]+)\@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
    PERCENTAGE: /[^0-9+-.%]/,
    NOT_NUMBER: /[^0-9\+\-\*\/\.\(\)]/g,
    NUMBER_WITH_UNIT: /(\-?\d+\.?\d*)([a-z\%]+)/g,
    JSON_KEY: /\s?([a-z\_\$][a-z\_\-\$]+)\s*\:/gi,
    JSON_STRING: /(^(?:\[.+\])|(?:\{[^\{].+[^\}]\}{1}))/, // will only match "[ ... ]" and "{ ... }", not "{{ ... }}"
    STRING_VALUES:
      /((?:[a-z0-9-+_%\/\\]+(?:\(.+\))?)|(?:\d[^\s,]*)|(?:"[^"]+")|(?:'[^']+')|(?:\[.+\])|(?:\(.+\))|(?:\{[^}]+\})|(?:\{\{[^}]+\}\}))(?:$|(?:\,\s*)|(?:\;\s*)|\s)/g,
    APOSTROPHES: /^['"](.+)['"]$/g,
  };

  this.string = {};
  this.array = {};
  this.object = {};
  this.fn = {};
  this.media = {};
  this.storage = {};
  this.dom = {};

  // validation ------------------------------------------------------------------------------------------------------
  this.is = function (v) {
    return !!(v || v === 0 || v === '0');
  };
  this.is.not = function (v) {
    return v === null || v === undefined || v === '' || v === false;
  };
  this.is.valid = function (v) {
    return !(
      v === null ||
      v === undefined ||
      (typeof v === 'number' && (isNaN(v) || !isFinite(v))) ||
      (v instanceof Date && isNaN(v))
    );
  };
  this.is.invalid = function (v) {
    return !utils.is.valid(v);
  };
  this.is.defined = this.is.def = function (v) {
    return v !== undefined;
  };
  this.is.null = function (v) {
    return v === null;
  };
  this.is.string = this.is.str = function (v) {
    return typeof v === 'string';
  };
  this.is.number = this.is.nbr = function (v) {
    return typeof v === 'number';
  };
  this.is.numeric = function (v) {
    return !isNaN(parseFloat(v)) && isFinite(v);
  };
  this.is.boolean = this.is.bool = function (v) {
    return typeof v === 'boolean';
  };
  this.is.object = this.is.obj = function (v, isPlain) {
    return isPlain
      ? v !== null && typeof v === 'object' && Object.getPrototypeOf(v) == Object.prototype
      : v !== null && typeof v === 'object';
  };
  this.is.array = this.is.arr = function (v, isStrict) {
    return isStrict ? Object.getPrototypeOf(v) == Array.prototype : v instanceof Array;
  };
  this.is.function = this.is.fn = function (v) {
    return typeof v === 'function';
  };
  this.is.node = function (v, type) {
    var isNode =
      typeof Node === 'object'
        ? v instanceof Node
        : v && typeof v === 'object' && typeof v.nodeType === 'number' && typeof v.nodeName === 'string';

    if (isNode && type) {
      if (type === 'text') isNode = v.nodeType === Node.TEXT_NODE;
      else if (type === 'comment') isNode = v.nodeType === Node.COMMENT_NODE;
      else if (typeof type === 'number') isNode = v.nodeType === type;
    }

    return isNode;
  };
  // this.is.element = this.is.el = function (v, tag){
  // 	var isElement = typeof HTMLElement === "object" || typeof SVGElement === 'object' ?
  // 		v instanceof HTMLElement || v instanceof SVGElement :
  // 		v && typeof v === "object" && v !== null && v.nodeType === 1 && typeof v.nodeName==="string";

  // 	if (isElement && tag){
  // 		isElement = v.tagName.toLowerCase() === tag.toLowerCase();
  // 	}

  // 	return !!isElement;
  // };
  this.is.element = this.is.el = function (v, tagOrQuery) {
    var isElement =
      typeof HTMLElement === 'object' || typeof SVGElement === 'object'
        ? v instanceof HTMLElement || v instanceof SVGElement
        : v && typeof v === 'object' && v !== null && v.nodeType === 1 && typeof v.nodeName === 'string';

    if (isElement && typeof tagOrQuery === 'string') {
      var tags = utils.toArray(tagOrQuery);
      var tag = v.tagName.toLowerCase();
      isElement = !!~tags.indexOf(tag);
    } else if (tagOrQuery === true && utils.is.query(v)) {
      isElement = true;
    }

    return !!isElement;
  };
  this.is.dom = function (v, isRoot, includeWindow) {
    includeWindow = includeWindow === undefined ? true : includeWindow;
    var isRootElement =
      v && ((includeWindow && v === window) || v === document || v === document.body || v === document.documentElement);
    return isRoot ? isRootElement : isRootElement || utils.is.element(v);
  };
  this.is.query = function (v) {
    return (
      v instanceof NodeList ||
      v instanceof HTMLCollection ||
      (window.jQuery && v instanceof jQuery) ||
      (v instanceof Array && utils.is.node(v[0]))
    );
  };
  this.is.input = function (v) {
    return v instanceof HTMLInputElement;
  };
  this.is.svg = function (v) {
    return v instanceof SVGElement;
  };
  this.is.empty = function (v) {
    if (typeof v === 'string' && v.trim() === '') {
      return true;
    } else if (Array.isArray(v) && !v.length) {
      return true;
    } else if (typeof v === 'object') {
      for (var i in v) {
        return false;
      }
      return true;
    } else if (v === undefined || v === null) {
      return true;
    }
    return false;
  };
  this.is.enumerable = function (v) {
    return !!(v instanceof Array || (v && typeof v === 'object' && v.length !== undefined));
  };
  this.is.either = function (v, types) {
    if (!utils.is.valid(v)) return false;

    types = utils.toArray(types);

    var i = 0,
      l = types.length,
      t;
    for (; i < l; ++i) {
      t = types[i];
      if (t in utils.is && utils.is[t](v)) {
        return utils.is[t](v);
      }
    }

    return false;
  };
  this.is.email = function (v) {
    return utils.is.string(v) && !!v.match(RE.EMAIL);
  };
  this.is.encoded = function (v) {
    if (typeof v !== 'string' || v === '' || v.trim() === '') return false;

    try {
      return btoa(atob(v)) == v;
    } catch (err) {
      return false;
    }
  };

  // helpers ---------------------------------------------------------------------------------------------------------
  this.defined = function () {
    var list = arguments;

    if (list.length === 1 && Array.isArray(list[0])) {
      list = list[0];
    }

    for (var i in list) {
      if (utils.is.defined(list[i])) {
        return list[i];
      }
    }

    return null;
  };

  this.extend = function () {
    var copies = [];
    var clones = [];

    function _walk() {
      var target = arguments[0];

      if (target === undefined || target === null) {
        return target;
      }

      var isDeep = false;
      var i = 1;
      var length = arguments.length;

      if (typeof target === 'boolean') {
        isDeep = !!target;
        target = arguments[i] || {};
        i++;
      }

      for (; i < length; ++i) {
        var item = arguments[i];

        // add the current target/copie to list of clones and copies (when refering to "same" item)
        if (isDeep) {
          clones.push(target);
          copies.push(item);
        }

        for (var name in item) {
          var src = target[name];
          var copy = item[name];
          var copyIndex = isDeep ? copies.indexOf(copy) : -1;
          var clone;

          // skip infinity loop
          if (target === copy) {
            continue;
          }

          if (~copyIndex) {
            target[name] = clones[copyIndex];
          } else if (isDeep && copy && (Array.isArray(copy) || utils.is.object(copy, true))) {
            // make sure to create a new Array/Object when it's an inherited property
            if (!target.hasOwnProperty(name)) {
              src = null;
            }

            if (Array.isArray(copy)) {
              clone = src && Array.isArray(src) ? src : [];
            } else {
              clone = src && utils.isPlainObject(src) ? src : {};
            }

            copies.push(copy);
            clones.push(clone);
            target[name] = _walk(isDeep, clone, copy);
          } else {
            target[name] = copy;
          }
        }
      }

      return target;
    }

    var response = _walk.apply(this, arguments);

    return response;
  };

  this.defaults = function (obj, defaults, isCopy) {
    obj = obj || {};
    var i;
    for (i in defaults) {
      if (i in obj) continue;
      obj[i] = isCopy ? utils.copy(defaults[i]) : defaults[i];
    }
    return obj;
  };

  this.copy = function (obj, props) {
    if (utils.is.arr(obj)) {
      return utils.extend(true, [], obj, props || []);
    } else if (utils.is.obj(obj)) {
      return utils.extend(true, {}, obj, props || {});
    } else {
      return obj;
    }
  };

  this.each = function (list, args, callback) {
    if (typeof args === 'function') {
      callback = args;
      args = {};
    }

    args = args || {};
    args.type = 'type' in args ? args.type : null;
    args.args = 'args' in args ? args.args : false;
    args.context = 'context' in args ? args.context : list;

    args.separator = 'separator' in args ? args.separator : ',';
    args.trim = 'trim' in args ? args.trim : true;
    args.lowercase = 'lowercase' in args ? args.lowercase : false;
    args.update = 'update' in args ? args.update : false;
    args.reindex = 'reindex' in args ? args.reindex : false;
    args.filter = 'filter' in args ? args.filter : false;

    args.continue = 'continue' in args ? args.continue : CONTINUE;
    args.break = 'break' in args ? args.break : BREAK;

    // [normal, reverse]
    args.order = 'order' in args ? args.order : false;
    if (args.reverse) {
      args.order = 'reverse';
    }

    var keys = [];
    var length = 0;
    var type = null;

    if (list === null) {
      list = [];
      type = 'null';
    } else if (typeof list === 'number') {
      keys = null;
      length = list;
      type = 'number';
    } else if (typeof list === 'string') {
      keys = null;
      list = list
        .trim()
        .split(args.separator)
        .filter(function (v) {
          return v.trim() !== '';
        });
      type = 'string';
      length = list.length;
    } else if (utils.is.enumerable(list)) {
      keys = null;
      length = list.length;
      type = 'array';
    } else {
      var keys = [],
        i;
      for (i in list) {
        if (list.hasOwnProperty(i)) {
          keys.push(i);
        }
      }
      length = keys.length;
      type = 'object';
    }

    if (args.reindex) {
      type = 'object';
    }

    // forced type
    if (args.type) {
      type = args.type;
    }

    function _get(index) {
      if (args.order === 'reverse' || args.order === 'backward') {
        index = length - index - 1;
      }

      var key = keys ? keys[index] : index;
      var value = type === 'number' ? index + 1 : list[key];

      return {
        index: index,
        key: key,
        value: value,
      };
    }

    var items = type === 'object' ? {} : [];
    var i, l, a, item, response, previous, next;
    for (i = 0, l = length; i < l; ++i) {
      item = _get(i);

      if (typeof item.value === 'string') {
        if (args.trim) item.value = item.value.trim();
        if (args.lowercase) item.value = item.value.toLowerCase();
      }

      response = undefined;
      if (typeof callback === 'function') {
        previous = _get(i - 1);
        next = _get(i + 1);

        a = args.args || {};
        a.index = i;
        a.isFirst = i === 0;
        a.isLast = i === length - 1;
        a.ratio = (i + 1) / length;
        a.key = item.key;
        a.length = length;
        a.type = type;
        a.previousKey = previous.key;
        a.nextKey = next.key;
        a.previous = previous.value;
        a.next = next.value;

        response = callback.apply(args.context || item.value, [item.value, item.key, a]);
      } else {
        response = item.value;
      }

      if (response === args.continue) {
        continue;
      } else if (response === args.break) {
        break;
      } else if (response !== undefined && args.update) {
        list[item.key] = response;
      }

      if (response !== undefined || !args.filter) {
        if (response === undefined) {
          response = item.value;
        }

        if (utils.is.obj(response) && '$id' in response) {
          if (items instanceof Array) {
            items = {};
          }

          var id = response['$id'];
          var value = response['$value'] ? response['$value'] : response;

          delete response['$id'];
          delete response['$value'];

          items[id] = value;
        } else if (type === 'object') {
          items[item.key] = response;
        } else {
          items.push(response);
        }
      }
    }

    return items;
  };

  this.each.context = function (ctx, list, args, callback) {
    if (typeof args === 'function') {
      callback = args;
      args = {};
    }

    args = args || {};
    args.context = args.context || ctx;

    return utils.each(list, args, callback);
  };

  this.match = function (item, search, args) {
    args = args || {};
    args.case = 'case' in args ? args.case : true;

    var iType = typeof item;
    var sType = typeof search;

    if (
      item === search ||
      (iType === 'string' && iType === sType && !args.case && item.toLowerCase() === search.toLowerCase()) ||
      (iType === 'string' && search instanceof RegExp && item.match(search)) ||
      (sType === 'function' && search.call(item, item) === true)
    ) {
      return true;
    }

    return false;
  };

  this.apply = function (callback, args, context) {
    var response = utils.is.arr(args) ? args[0] : null;

    if (typeof callback === 'function') {
      var r = callback.apply(context, args);
      if (utils.is.valid(r)) {
        response = r;
      }
    }

    return response;
  };

  this.cache = function (obj, key, value, expando) {
    if (!typeof obj === 'object') {
      return null;
    }

    expando = expando || EXPANDO;

    var set = utils.toSet(key, value);
    var data = obj[expando] || (obj[expando] = {});

    if (Array.isArray(key)) {
      var complex = data['__COMPLEX__'] || (data['__COMPLEX__'] = []);
      var index = null;
      var i = 0,
        l = complex.length,
        item,
        ii,
        ll;

      // find the complex index
      loop_items: for (; i < l; ++i) {
        item = complex[i];
        ii = 0;
        ll = key.length;

        if (item.key.length !== key.length) continue;

        loop_keys: for (; ii < ll; ++ii) {
          if (item.key[ii] !== key[ii]) {
            continue loop_items;
          }
        }

        index = i;
        break;
      }

      if (index === null) {
        index = complex.length;
      }

      if (utils.is.defined(value)) {
        if (value === null) {
          complex.splice(index, 1);
        } else {
          complex[index] = { key: key, value: value };
        }
        return data;
      } else {
        return complex[index] ? complex[index].value : null;
      }
    } else if (set) {
      utils.extend(data, set);
      return data;
    } else if (key !== undefined) {
      return data[key];
    } else {
      return data;
    }
  };

  this.calculate = function (nbr, units, args) {
    if (typeof units === 'number') {
      units = { '%': units };
    }
    if (typeof args === 'number') {
      args = { offset: args };
    }

    units = units || {};
    args = args || {};
    args.offset = 'offset' in args ? args.offset : 0;

    if (units['%'] === undefined) {
      units['%'] = 1;
    }

    var isFloor = false;
    var isRound = false;
    var isCeil = false;
    var isHalf = false;

    if (typeof nbr === 'string') {
      isFloor = !!~nbr.indexOf('!floor');
      isRound = !!~nbr.indexOf('!round');
      isCeil = !!~nbr.indexOf('!ceil');
      isHalf = !!~nbr.indexOf('!half'); // add half a pixel
    }

    if (nbr === undefined || nbr === null) {
      nbr = 0;
    } else if (!isNaN(nbr)) {
      nbr = parseFloat(nbr);
    } else if (nbr === '?' || nbr === 'random') {
      nbr = Math.random() * units['%'];
    } else if (typeof nbr === 'string' && !nbr.match(RE.PERCENTAGE)) {
      nbr = (parseFloat(nbr) / 100) * units['%'];
    } else if (typeof nbr === 'string') {
      // random numbers (the previous ifs are shortcuts when the string is simpler, makes things faster)
      nbr = nbr.replace(/\?/g, function () {
        return Math.random() * units['%'];
      });

      nbr = nbr.replace(RE.NUMBER_WITH_UNIT, function (m, $1, $2) {
        var n = parseFloat($1);

        if ($2 in units) {
          n = (n / 100) * units[$2];
        } else {
          n = m;
        }

        return n;
      });
    }

    if (typeof nbr === 'string') {
      nbr = nbr.replace(RE.NOT_NUMBER, '');
      try {
        nbr = eval(nbr);
      } catch (e) {}
    }

    nbr = nbr || 0;

    if (args.offset) {
      nbr += args.offset;
    }

    if (isFloor) nbr = ~~nbr;
    if (isRound) nbr = Math.round(nbr);
    if (isCeil) nbr = Math.ceil(nbr);
    if (isHalf) nbr = ~~nbr + 0.5; // half decimals, good to graphic when we need half a pixel

    return nbr;
  };

  this.clamp = function (nbr, min, max) {
    if (min === undefined && max === undefined) {
      min = 0;
      max = 1;
    }
    if (max === undefined) {
      max = min;
      min = 0;
    }
    return Math.max(Math.min(max, nbr), min);
  };

  this.animate = function (args, callback) {
    if (utils.is.fn(args)) {
      callback = args;
      args = {};
    }

    args = args || {};
    args.context = args.context || null;
    args.frames = args.frames || null; // animate by a number of frames
    args.duration = args.duration || 1000; // animate by a durations
    args.easing = args.easing || null;
    args.loop = 'loop' in args ? args.loop : false;
    args.fps = 'fps' in args ? args.fps : null;
    args.now = 'now' in args ? args.now : true;

    if (args.frames) {
      args.frames = Math.abs(args.frames) | 0;
    }

    var start = +new Date();
    var request = null;
    var lastFrame = -1;
    var looped = 0;
    var self = { isPlaying: false };

    function _tick() {
      self.isPlaying = true;

      var time = +new Date() - start;
      if (args.duration && time > args.duration) {
        time = args.duration;
      }

      var ratio = 0;
      var frame = 0;

      // animation by frames
      if (args.frames) {
        frame = lastFrame + 1;
        ratio = frame / args.frames;
        // animation by duration
      } else {
        ratio = time / args.duration;
        frame = Math.floor(args.fps ? (time / 1000) * args.fps : lastFrame + 1);
      }

      if (frame !== lastFrame) {
        var r = utils.is.fn(args.easing) ? args.easing(ratio) : ratio;
        var e = {
          time: time,
          ratio: r,
          progress: ratio,
          frame: frame,
          isStart: ratio <= 0,
          isEnd: ratio >= 1,
          looped: looped,
        };

        var response = callback.apply(args.context || self, [r, e]);
        if (response === false) {
          self.isPlaying = false;
        }
      }

      var nextFrame = self.isPlaying && (!args.duration || ratio < 1);
      if (args.loop && ratio >= 1) {
        start = +new Date();
        nextFrame = true;
        looped++;
      }

      // next frame
      if (nextFrame) {
        lastFrame = frame;
        request = utils.fn.requestFrame(_tick);
      }
    }

    self.play = function () {
      self.isPlaying = true;
      _tick();
    };

    self.stop = function () {
      self.isPlaying = false;
      utils.fn.cancelFrame(request);
    };

    if (args.now) {
      self.play();
    }

    return self;
  };

  this.toArray = function (list, args) {
    if (!list && list !== 0) {
      return [];
    }

    if (utils.is.str(args)) {
      args = { separator: args };
    } else if (utils.is.bool(args)) {
      args = { unique: args };
    }

    args = args || {};
    args.map = 'map' in args ? args.map : null;
    args.separator = 'separator' in args ? args.separator : ',';
    args.unique = 'unique' in args ? args.unique : false;

    var arr = [];
    if (utils.is.arr(list, true)) {
      arr = list;
    } else if (utils.is.enumerable(list)) {
      var i = 0,
        l = list.length;
      for (; i < l; ++i) {
        arr.push(list[i]);
      }
    } else if (utils.is.object(list)) {
      for (var i in list) {
        arr.push(list[i]);
      }
    } else if (typeof list === 'string') {
      if (args.separator instanceof RegExp) {
        arr = list.match(args.separator);
      } else {
        arr = list.split(args.separator);
      }
      arr = arr.map(function (v) {
        return v.trim();
      });
    } else if (list !== undefined) {
      arr = [list];
    }

    if (args.unique) {
      arr = utils.array.unique(arr);
    }

    if (utils.is.fn(args.map)) {
      arr.map(args.map);
    }

    return arr;
  };

  this.toSet = function (key, value, fallback) {
    if (typeof key === 'object') {
      return key;
    } else if (value !== undefined) {
      var values = {};
      values[key] = value;
      return values;
    } else {
      return fallback;
    }
  };

  this.toValue = function (str, args) {
    if (typeof str !== 'string' || str === '') {
      return str;
    }

    args = args || {};
    args.context = 'context' in args ? args.context : null;
    args.clean = 'clean' in args ? args.clean : true;
    args.json = 'json' in args ? args.json : false;

    var value = str.trim();

    if (value === 'true') {
      value = true;
    } else if (value === 'false') {
      value = false;
    } else if (value === 'null' || value === 'undefined' || value === null || value === undefined) {
      value = null;
    } else if (!isNaN(value) && value !== '') {
      value = parseFloat(value);
    } else if (value === 'this') {
      value = args.context;
    } else if (args.json && value.match(RE.JSON_STRING)) {
      value = utils.toJson(value, false) || value;
    }

    return value;
  };

  this.toValues = function (str, args) {
    var values = [];

    if (!str) {
      return values;
    }

    if (str instanceof Array) {
      for (var i in str) {
        var value = args !== false ? utils.toValue(str[i], args) : value;
        values.push(value);
      }
    } else if (typeof str === 'string') {
      // @info this does not work with complex string like : `"text", 1234, true, { a : "value" }` the object isn't parsed properly
      str.replace(RE.STRING_VALUES, function (m, $1) {
        var value = args !== false ? utils.toValue($1, args) : $1;

        if (args === false) {
          value = value.replace(RE.APOSTROPHES, '$1');
        }

        values.push(value);
      });
    }

    return values;
  };

  this.toBounds = function (data, args) {
    args = args || {};
    args.offsetX = 'offsetX' in args ? args.offsetX : 0;
    args.offsetY = 'offsetY' in args ? args.offsetY : 0;
    args.padding = 'padding' in args ? args.padding : null;
    args.margin = 'margin' in args ? args.margin : null;

    var p;
    if (Array.isArray(args.margin)) {
      p = args.margin.map(function (v) {
        return -v;
      });
    } else if (Array.isArray(args.padding)) {
      p = args.padding;
    }
    if (!Array.isArray(p) || p.length !== 4) {
      p = [0, 0, 0, 0];
    }

    var x, y, w, h;
    if (data instanceof Array) {
      x = data[0] || 0;
      y = data[1] || 0;
      w = data[2] || 0;
      h = data[3] || 0;
    } else if (typeof data === 'object') {
      x = 'x' in data ? data.x : 'left' in data ? data.left : 0;
      y = 'y' in data ? data.y : 'top' in data ? data.top : 0;
      w = 'w' in data ? data.w : 'width' in data ? data.width : 'right' in data ? data.right - x : 0;
      h = 'h' in data ? data.h : 'height' in data ? data.height : 'bottom' in data ? data.bottom - y : 0;

      // radius for circles
      if ('radius' in data) {
        x -= data.radius;
        y -= data.radius;
        w = data.radius * 2;
        h = data.radius * 2;
      }
    }

    x = (isFinite(x) ? x : 0) + p[3] + args.offsetX;
    y = (isFinite(y) ? y : 0) + p[0] + args.offsetY;
    w = (isFinite(w) ? w : 0) - (p[3] + p[1]);
    h = (isFinite(h) ? h : 0) - (p[0] + p[2]);

    // make sure the height/width are not negative
    if (h < 0) h = 0;
    if (w < 0) w = 0;

    var cx = x + w / 2;
    var cy = y + h / 2;

    return {
      top: y,
      right: x + w,
      bottom: y + h,
      left: x,
      x: x,
      y: y,
      width: w,
      height: h,
      centerX: cx,
      centerY: cy,
      center: { x: cx, y: cy },
    };
  };

  this.toJson = function (str, args) {
    if (typeof str !== 'string') {
      return str;
    }

    args = (typeof args === 'function' ? { normalize: args } : args) || {};
    args.normalize = 'normalize' in args ? args.normalize : false;
    args.context = 'context' in args ? args.context : null;
    args.warn = 'warn' in args ? args.warn : false;

    if (args.normalize) {
      str = str.replace(/\'/g, '"');
      str = str.replace(/\/\/.+/g, '');
      str = str.replace(RE.JSON_KEY, '"$1":');
      str = str.trim();

      // remove the first and last "{/}" to be able to remove the last ","
      if (!str.match(/^[\{\[].+[\}\]]$/)) {
        str = str.replace(/^\{|\}$/g, '');
        str = str.replace(/\,$/, '');
        str = '{' + str + '}';
      }
    } else {
      str = str.replace(/^\/\/.*/gm, ''); // remove comments

      // make sure there's a brackets
      if (str[0] !== '{' && str[0] !== '[') {
        str = '{' + str + '}';
      }
    }

    var json = null;
    try {
      var fn = eval('(function (){ return function (){ return ' + str + '; } }())');
      json = fn.apply(args.context);
    } catch (e) {
      if (args.warn) {
        utils.warn("The JSON string couldn't be eval().\n{error}\n\n{str}", { error: e, str: str });
      }
    }

    return json;
  };

  this.encode = function (data) {
    if (!utils.is.valid(data)) return null;
    data = JSON.stringify(data);
    data = window.btoa(unescape(encodeURIComponent(data)));
    return data;
  };

  this.decode = function (data) {
    try {
      data = decodeURIComponent(escape(window.atob(data)));
      data = JSON.parse(data);
    } catch (e) {
      data = null;
    }

    return utils.is.valid(data) ? data : null;
  };

  this.popup = function (href, args) {
    args = args || {};
    args.width = args.width || screen.width / 2;
    args.height = args.height || screen.height / 2;
    args.target = args.target || '';
    args.toolbar = args.toolbar || false;
    args.status = args.status || false;
    args.context = args.context || null;
    args.onClose = args.onClose || null;

    var left = (screen.width - args.width) / 2;
    var top = (screen.height - args.height) / 2;
    var win = window.open(
      href,
      args.target,
      'toolbar=' +
        (args.toolbar ? 1 : 0) +
        ',status=' +
        (args.status ? 1 : 0) +
        ',width=' +
        args.width +
        ',height=' +
        args.height +
        ',left=' +
        left +
        ',top=' +
        top
    );

    if (win) {
      win.focus();
    }

    if (utils.is.fn(args.onClose)) {
      var interval = setInterval(function () {
        if (win.closed !== false) {
          clearInterval(interval);
          utils.apply(args.onClose, null, args.context);
        }
      }, 300);
    }

    return win;
  };

  // string ----------------------------------------------------------------------------------------------------------
  RE.REPLACE_VARS = /\{([^}|]+)(?:\|([^}]*))?\}/g;

  this.string.random = function (prefix, separator) {
    separator = utils.defined(separator, '_');
    return (prefix ? prefix + separator : '') + Math.floor(Math.random() * 0xffffff).toString(16);
  };

  this.string.camel2dash = function (str) {
    str = str.replace(/([A-Z])/g, function (m, $1) {
      return '-' + $1.toLowerCase();
    });
    if (str[0] === '-') {
      str = str.slice(1);
    }
    return str;
  };

  this.string.dash2camel = function (str) {
    str = str.replace(/-{2,}/g, '-').replace(/-([a-z])/gi, function (m, $1) {
      return $1.toUpperCase();
    });
    return str;
  };

  this.string.replace = function (str, data, args) {
    if (typeof str !== 'string' || !~str.indexOf('{') || !data) {
      return str;
    }

    // make sure the string variables are single "{" and "}"
    str = str.replace(/\{{2}/g, '{').replace(/\}{2}/g, '}');

    args = args || {};
    args.fallback = 'fallback' in args ? args.fallback : '';
    args.separator = 'separator' in args ? args.separator : '';

    function _get(data, key) {
      var value = undefined;

      if (typeof data === 'function') {
        value = data(key);
      } else if (data[key] !== undefined) {
        value = data[key];
      }

      if (typeof value === 'function') {
        value = value();
      }

      return value;
    }

    if (data instanceof Array) {
      var items = [];
      var i = 0,
        l = data.length,
        item;
      for (; i < l; ++i) {
        item = utils.is.obj(data[i]) ? { value: data[i] } : data[i];
        item = utils.string.replace(str, item, { fallback: args.fallback, paths: args.paths });
        items.push(item);
      }
      return items.join(args.separator);
    } else {
      // Variable replacement
      str = str.replace(RE.REPLACE_VARS, function (match, $1, $2) {
        var keys = $1.trim().split(',');
        var i = 0,
          l = keys.length,
          k,
          v;

        for (; i < l; ++i) {
          k = keys[i];
          v = _get(data, k);

          if (v !== undefined) {
            break;
          }
        }

        if (v === undefined && $2 === undefined) {
          return args.fallback !== null ? args.fallback : '{' + $1 + '}';
        } else if (v === undefined) {
          return $2;
        } else {
          return v;
        }
      });
    }

    return str;
  };

  this.string.match = function (str, re, singleOrCallback) {
    var isSingle = singleOrCallback === true;
    var callback = typeof singleOrCallback === 'function' ? singleOrCallback : null;
    var groups = [];
    var match = null;
    var max = 100;
    var i = 0;
    var l = 0;
    var value;

    if (re.global) {
      while ((match = re.exec(str)) !== null && max > 0) {
        value = match;

        if (callback) {
          value = callback.apply(null, match);
        } else if (value.groups) {
          value = value.groups;
        } else {
          value = [];
          for (i = 1, l = match.length; i < l; ++i) {
            value.push(match[i]);
          }
        }

        groups.push(value);
        max--;
      }
    } else if ((match = str.match(re))) {
      if (match.groups && callback) {
        groups = callback.call(null, match.groups);
      } else if (match.groups) {
        groups = match.groups;
      } else {
        for (i = 1, l = match.length; i < l; ++i) {
          value = match[i];

          if (callback) {
            value = callback.call(null, value, i - 1);
          }

          groups.push(value);
        }
      }
    }

    return isSingle ? groups[0] : groups;
  };

  this.string.toDuration = function (str) {
    if (str === null || str === undefined) {
      str = 0;
    }

    if (typeof str === 'string') {
      var time = parseFloat(str);

      if (~str.indexOf('min')) {
        time *= 60000;
      } else if (~str.indexOf('hour')) {
        time *= 3.6e6;
      } else if (~str.indexOf('day')) {
        time *= 8.64e7;
      } else if (~str.indexOf('week')) {
        time *= 6.048e8;
      } else if (~str.indexOf('month')) {
        time *= 2.628e9;
      } else if (~str.indexOf('year')) {
        time *= 3.154e10;
      } else if (~str.indexOf('ms')) {
        time = time;
      } else if (~str.indexOf('s')) {
        time *= 1000;
      }
    } else {
      time = str;
    }

    return isNaN(time) ? 0 : time;
  };

  // array -----------------------------------------------------------------------------------------------------------
  this.array.indexOf = function (arr, match) {
    var index = -1;

    if (match === 'first') {
      index = 0;
    } else if (match === 'last') {
      index = arr.length - 1;
    } else {
      var i, l;
      for (i = 0, l = arr.length; i < l; ++i) {
        if (utils.match(arr[i], match)) {
          index = i;
          break;
        }
      }
    }

    return index;
  };

  this.array.get = function (arr, match) {
    var index = utils.array.indexOf(arr, match);
    return arr[index];
  };

  this.array.unique = function (arr) {
    var unique = [];
    var i = 0,
      l = arr.length,
      v;
    for (; i < l; ++i) {
      v = arr[i];
      if (!~unique.indexOf(v)) {
        unique.push(v);
      }
    }
    return unique;
  };

  this.array.remove = function (arr, match) {
    var index = utils.array.indexOf(arr, match);
    var item = null;
    if (!!~index) {
      item = arr[index];
      arr.splice(index, 1);
    }
    return item;
  };

  this.array.diff = function (arr1, arr2, reverse) {
    arr1 = utils.toArray(arr1);
    arr2 = utils.toArray(arr2);

    var intersects = [];
    var diffs = [];
    var length = Math.max(arr1.length, arr2.length);
    var i = 0,
      a,
      b;

    for (; i < length; ++i) {
      a = arr1[i];
      b = arr2[i];

      if (a !== undefined) {
        if (!~arr2.indexOf(a) && !~diffs.indexOf(a)) {
          diffs.push(a);
        } else if (!~intersects.indexOf(a)) {
          intersects.push(a);
        }
      }

      if (b !== undefined) {
        if (!~arr1.indexOf(b) && !~diffs.indexOf(b)) {
          diffs.push(b);
        } else if (!~intersects.indexOf(b)) {
          intersects.push(b);
        }
      }
    }

    if (utils.is.fn(reverse)) {
      reverse(diffs, intersects);
    }

    if (reverse === true) {
      return intersects;
    } else {
      return diffs;
    }
  };

  this.array.intersect = function (arr1, arr2) {
    return utils.array.diff(arr1, arr2, true);
  };

  // object ----------------------------------------------------------------------------------------------------------
  this.object.toQuerystring = function (obj) {
    var params = [];
    var i, ii, value, arr;

    for (i in obj) {
      value = obj[i];

      if (value instanceof Array) {
        arr = [];

        for (ii in value) {
          arr.push(i + '[]=' + encodeURIComponent(value[ii]));
        }
        if (arr.length) {
          params.push(arr.join('&'));
        } else {
          params.push(i + '[]');
        }
      } else if (typeof value === 'object') {
        // @nicetohave converting an object to a QueryString
      } else {
        params.push(i + '=' + encodeURIComponent(value) + '');
      }
    }

    return params.join('&');
  };

  this.object.toFormData = function (obj) {
    var data = new FormData();
    var i;

    for (i in obj) {
      _walk(i, obj[i]);
    }

    function _walk(path, value) {
      var ii;

      if (!utils.is(value) && value !== '') {
        value = null;
      }

      if (value instanceof Array) {
        for (ii in value) {
          _walk(path + '[]', value[ii]);
        }
        // empty array
        if (!value.length) {
          data.append(path + '[]', '');
        }
      } else if (value && typeof value === 'object') {
        for (i in value) {
          _walk(path + '[' + i + ']', value[i]);
        }
      } else {
        data.append(path, value);
      }
    }

    return data;
  };

  this.object.namespace = function (obj, value, args) {
    if (typeof obj === 'string') {
      var key = obj;
      obj = {};
      obj[key] = value;
    } else {
      args = value;
    }

    args = (typeof args === 'string' ? { separator: args } : args) || {};
    args.separator = 'separator' in args ? args.separator : '.';
    args.arraySets = 'arraySets' in args ? args.arraySets : false;

    var data = {};
    for (var key in obj) {
      var prev = data;
      var value = obj[key];
      var path;

      // if it's a set of array
      if (args.arraySets && value instanceof Array) {
        key = value[0];
        value = value[1];
      }

      if (args.separator === 'form') {
        path = key.replace(/\[/g, '.').replace(/\]/g, '').split('.');
      } else {
        path = key.split(args.separator);
      }

      for (var i = 0, l = path.length; i < l; ++i) {
        var index = (path[i] || prev.length.toString()).trim();
        var nIndex = (path[i + 1] || '0').trim();

        if (i === path.length - 1) {
          prev[index] = value;
        } else if (!isNaN(nIndex)) {
          prev = prev[index] = prev[index] || [];
        } else {
          prev = prev[index] = prev[index] || {};
        }
      }
    }

    return data;
  };

  // function --------------------------------------------------------------------------------------------------------
  CONSTS.WHEN = {};

  this.fn.empty = function (v) {
    return v;
  };

  this.fn.requestFrame = function (callback, isDouble) {
    if (!window.requestFrame) {
      window.requestFrame =
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        (function () {
          var timeLast = 0;
          return function (fn) {
            var timeCurrent = new Date().getTime();
            var timeDelta;

            // Dynamically set the delay on a per-tick basis to more closely match 60fps.
            // Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671.
            timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
            timeLast = timeCurrent + timeDelta;

            return setTimeout(function () {
              fn(timeCurrent + timeDelta);
            }, timeDelta);
          };
        })();
    }

    var request = {
      id: null,
    };

    if (isDouble) {
      request.id = window.requestFrame(function () {
        request.id = window.requestFrame(callback);
      });
    } else {
      request.id = window.requestFrame(callback);
    }

    return request;
  };

  this.fn.cancelFrame = function (request) {
    if (!request) return;

    if (!window.cancelFrame) {
      window.cancelFrame =
        window.cancelAnimationFrame ||
        window.webkitCancelRequestAnimationFrame ||
        window.webkitCancelAnimationFrame ||
        window.mozCancelRequestAnimationFrame ||
        window.mozCancelAnimationFrame ||
        window.oCancelRequestAnimationFrame ||
        window.oCancelAnimationFrame ||
        window.msCancelRequestAnimationFrame ||
        window.msCancelAnimationFrame ||
        function (id) {
          return clearTimeout(request.id);
        };
    }

    void window.cancelFrame(request.id);
  };

  this.fn.sync = function (args) {
    if (utils.is.fn(args)) {
      args = { onChange: args };
    }

    args = args || {};
    args.context = args.context || null;
    args.debounce = 'debounce' in args ? args.debounce : 300;
    args.throttle = 'throttle' in args ? args.throttle : 300;
    args.format = args.format || null;
    args.onStart = args.onStart || null;
    args.onChange = args.onChange || null;
    args.onEnd = args.onEnd || null;
    args.onAll = args.onAll || null;

    var timeout = null;
    var wait = false;
    var hasStarted = false;
    var startData = null;

    function _apply(fn, params) {
      return utils.apply(fn, params, args.context);
    }

    function _callback(data) {
      // format the data
      if (utils.is.fn(args.format)) {
        var response = _apply(args.format, [data, startData]);
        if (response !== undefined) {
          data = response;
        }
      }

      // start callback
      if (!hasStarted && utils.is.fn(args.onStart)) {
        if (typeof data === 'object') {
          data.isStart = true;
          data.isEnd = false;
        }
        startData = data;
        _apply(args.onStart, [data]);
      }

      // always callback
      if (utils.is.fn(args.onAll)) {
        _apply(args.onAll, [data]);
      }

      // change callback
      if (!wait && utils.is.fn(args.onChange)) {
        if (typeof data === 'object') {
          data.isStart = false;
          data.isEnd = false;
        }

        _apply(args.onChange, [data]);

        wait = true;

        // requestAnimationFrame
        if (args.throttle === true) {
          utils.fn.requestFrame(function () {
            wait = false;
          });
          // timeout
        } else if (typeof args.throttle === 'number') {
          setTimeout(function () {
            wait = false;
          }, args.throttle);
          // all the time
        } else {
          wait = false;
        }
      }

      // end callback
      hasStarted = true;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        if (typeof data === 'object') {
          data.isStart = false;
          data.isEnd = true;
        }

        hasStarted = false;
        startData = null;

        if (utils.is.fn(args.onEnd)) {
          _apply(args.onEnd, [data]);
        }
      }, args.debounce);
    }

    return _callback;
  };

  this.fn.all = function (callbacks, context, onComplete) {
    /*
		if (typeof context === 'function'){
			onComplete = context;
			context    = null;
		}

		var count     = 0;
		var total     = callbacks.length;
		var responses = [];

		function _done (){
			count++;

			if (count >= total){
				onComplete();
			}
		}

		for (var i=0, l=callbacks.length; i<l; ++i){
			var item 		= callbacks[i];
			var callback 	= item;
			var args 		= [_done];
			var response 	= null;

			if ((callback instanceof Array) && typeof callback[0] === 'function'){
				callback = callback[0];
				args 	 = item.slice(1).concat(args);
			}
			if (typeof callback === 'function'){
				response = callback.apply(context, args);
				responses.push(response);
			}
		}

		return responses;
		*/
  };

  this.fn.when = function (key, callback, data, context) {
    data = data || CONSTS.WHEN;

    var value = data[key];

    // call callbacks
    if (!utils.is.valid(callback)) {
      // @info when there's has been no callbacks and wasn't changed to true, the result is null
      if (value === true) {
        return true;
      } else if (value === false || value instanceof Array) {
        // array is a list of callbacks
        return false;
      } else {
        return null;
      }
    }

    var isDone = value === true;
    if (utils.is.fn(callback)) {
      if (isDone) {
        utils.apply(callback, null, context);
      } else {
        value = utils.is.arr(value) ? value : [];
        value.push(callback);
      }
    } else if (callback === true) {
      var callbacks = utils.is.arr(value) ? value : [];
      var i = 0,
        l = callbacks.length;

      // need to put at true value before doing the callbacks, if the callback try asking if the key is true
      data[key] = true;

      for (; i < l; ++i) {
        utils.apply(callbacks[i], null, context);
      }
      value = true;
    } else if (callback === false) {
      value = false;
    }

    data[key] = value;

    return value;
  };

  // media -----------------------------------------------------------------------------------------------------------
  CONSTS.HTTP_QUEUE = {};

  this.media.require = function (url, args, callback) {
    if (utils.is.fn(args)) {
      callback = args;
      args = {};
    }

    args = args || {};
    args.async = 'async' in args ? args.async : true;
    args.type = args.type || '';
    args.context = 'context' in args ? args.context : null;

    var head = document.getElementsByTagName('head')[0];
    var isCss = !!~url.indexOf('.css');

    function _done(success) {
      if (utils.is.fn(callback)) {
        callback.apply(args.context, [success, url]);
      }
    }

    if (isCss) {
      var link = document.createElement('link');

      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.media = 'all';
      link.onload = function () {
        _done(true);
      };
      link.onerror = function () {
        _done(false);
      };
      link.href = url;

      head.appendChild(link);
    } else {
      var script = document.createElement('script');

      script.type = args.type ? args.type : 'text/javascript';

      if (args.async) {
        script.async = 'true';
        script.defer = 'true';
      }

      // IE browser
      if (script.readyState) {
        script.onreadystatechange = function () {
          if (this.readyState !== 'loaded' && this.readyState !== 'complete') return;
          this.onreadystatechange = null;
          _done(true);
        };
        // other browsers
      } else {
        script.onload = function () {
          _done(true);
        };
        script.onerror = function () {
          _done(false);
        };
      }

      script.src = url;

      head.appendChild(script);
    }
  };

  this.media.requires = function (urls, args, callback) {
    if (utils.is.fn(args)) {
      callback = args;
      args = {};
    }

    args = args || {};
    args.simultaneous = 'simultaneous' in args ? args.simultaneous : true;
    args.delay = 'delay' in args ? args.delay : 0;
    args.async = 'async' in args ? args.async : true;
    args.context = 'context' in args ? args.context : null;

    var index = 0;
    var count = 0;
    var args2 = utils.extend({}, args);

    args2.simultaneous = false;

    function _next() {
      var url = urls[index++];

      if (utils.is.arr(url)) {
        utils.media.requires(url, args2, _check);
      } else if (url) {
        utils.media.require(url, args2, _check);
      } else {
        return;
      }

      if (args.simultaneous) {
        _next();
      }
    }

    function _check(s, u) {
      count++;

      if (count >= urls.length) {
        setTimeout(function () {
          utils.apply(callback, [true, urls], args.context);
        }, args.delay);
      }

      if (!args.simultaneous) {
        _next();
      }
    }

    _next();
  };

  this.media.http = function (url, data, args) {
    if (arguments.length <= 2) {
      args = data;
      data = null;
    }

    if (utils.is.fn(args)) {
      args = { callback: args };
    }

    args = args || {};
    args.data = args.data || data || null;
    args.callback = args.callback || null;
    args.type = args.type || null;
    args.context = args.context || null;
    args.selector = args.selector || null;
    args.queue = args.queue || null;
    args.method = args.method || (args.data ? 'post' : 'get');

    var queue = args.queue ? CONSTS.HTTP_QUEUE[args.queue] || (CONSTS.HTTP_QUEUE[args.queue] = []) : null;

    // there's a selector in the url
    var sIndex = url.indexOf(' ');
    if (!!~sIndex) {
      args.selector = url.slice(sIndex).trim();
      url = url.slice(0, sIndex);
    }

    var request = new XMLHttpRequest();
    url = utils.string.replace(url, args.data || {});

    if (args.method === 'get' && args.data) {
      url += (~url.indexOf('?') ? '&' : '?') + utils.object.toQuerystring(args.data);
    }

    function _toPart(data, selector) {
      if (utils.is.str(data)) {
        // @source jQuery code
        var doc = document.implementation.createHTMLDocument('');
        var base = doc.createElement('base');

        base.href = document.location.href;
        doc.head.appendChild(base);
        doc.body.innerHTML = data;

        var nodes = doc.body.querySelectorAll(selector);
        var root = document.createElement('div');
        var i = 0,
          l = nodes.length;
        for (; i < l; ++i) {
          root.appendChild(nodes[i]);
        }

        data = root.innerHTML;
      } else if (utils.is.obj(data)) {
        data = data[selector];
      }

      return data;
    }

    function _onChange() {
      if (request.readyState !== XMLHttpRequest.DONE) return;
      if (request.status === 0) {
        return; // aborded
      }

      var type = request.getResponseHeader('Content-Type') || args.type || '';
      var status = request.status;
      var allHeaders = request.getAllResponseHeaders().split('\n');
      var headers = {};
      var response = null;

      utils.each(allHeaders, function (head) {
        if ((head = head.trim())) {
          var pair = head.split(':');
          var key = pair[0].trim();
          var value = pair[1].trim();
          headers[key] = value;
        }
      });

      // parse the data
      if (type === 'application/json' || ~type.indexOf('json')) {
        response = JSON.parse(request.responseText);
        type = 'json';
      } else if (
        type === 'application/xml' ||
        type === 'text/xml' ||
        type === 'text/html' ||
        type === 'html' ||
        type === 'xml'
      ) {
        response = request.responseXml;
        type = 'xml';
      } else {
        response = request.responseText;
        type = 'text';
      }

      if (status === 200 && !response) {
        status = 204;
      }

      if (response && args.selector) {
        response = _toPart(response, args.selector);
      }

      if (utils.is.fn(args.callback)) {
        args.callback.apply(args.context, [
          response,
          status === 200,
          {
            type: type,
            headers: headers,
            request: request,
            status: status,
          },
        ]);

        if (queue) {
          queue.shift();

          if (queue.length) {
            queue[0]();
          }
        }
      }
    }

    function _call() {
      request.onreadystatechange = _onChange;

      // send request
      request.open(args.method, url, true);

      if (args.method === 'post' && args.data) {
        var data = utils.object.toFormData(args.data);
        request.send(data);
      } else {
        request.send();
      }
    }

    if (queue) {
      queue.push(_call);

      if (queue.length === 1) {
        _call();
      }
    } else {
      _call();
    }

    return request;
  };

  this.media.cancelHttp = function (request) {
    if (request && utils.is.fn(request.abort)) {
      request.abort();
    }
  };

  // storage ---------------------------------------------------------------------------------------------------------
  this.storage.set = function (key, value, type, duration) {
    type = type === true ? 'session' : type;

    var value = JSON.stringify(value);

    if (type === 'cookie') {
      var time = duration ? +new Date() + utils.string.toDuration(duration) : 0;
      var expire = time ? '; expires=' + new Date(time).toUTCString() : '';
      var path = '; path=/';
      var cookie = key + '=' + value + expire + path;
      document.cookie = cookie;
    } else {
      var storage = type === 'session' ? window.sessionStorage : window.localStorage;
      storage.setItem(key, value);
    }
  };

  this.storage.get = function (key, fallback, type) {
    type = type === true ? 'session' : type;

    var value;
    if (type === 'cookie') {
      var crumbs = document.cookie.split('; ');
      var key = key + '=';
      var crumb, i, l;

      for (i = 0, l = crumbs.length; i < l; ++i) {
        crumb = crumbs[i];
        if (crumb.indexOf(key) === 0) {
          value = crumb.replace(key, '');
          break;
        }
      }
    } else {
      var storage = type === 'session' ? window.sessionStorage : window.localStorage;
      value = storage.getItem(key);
    }

    try {
      value = value ? JSON.parse(value) : fallback;
    } catch (e) {
      value = null;
    }

    return value;
  };

  this.storage.clear = function (key, type) {
    type = type === true ? 'session' : type;

    if (type === 'cookie') {
      var cookie = key + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      document.cookie = cookie;
    } else {
      var storage = type === 'session' ? window.sessionStorage : window.localStorage;
      storage.removeItem(key);
    }
  };

  // dom -------------------------------------------------------------------------------------------------------------

  // global event ------------------------------------------------------------
  CONSTS.ON_READY = [];
  CONSTS.ON_LOAD = [];
  CONSTS.IS_READY = false;
  CONSTS.IS_LOADED = false;

  this.dom.isReady = function () {
    if (
      document.readyState === 'complete' ||
      (document.readyState !== 'loading' && !document.documentElement.doScroll)
    ) {
      CONSTS.IS_READY = true;
    }
    return CONSTS.IS_READY === true;
  };

  this.dom.isLoaded = function () {
    if (document.readyState === 'complete') {
      CONSTS.IS_LOADED = true;
    }
    return CONSTS.IS_LOADED === true;
  };

  this.dom.ready = function (callback) {
    if (utils.dom.isReady()) {
      callback();
    } else {
      CONSTS.ON_READY.push(callback);

      if (CONSTS.IS_READY === false) {
        CONSTS.IS_READY = 'loading';

        function _done() {
          CONSTS.IS_READY = true;
          utils.each(CONSTS.ON_READY, function (c) {
            c();
          });
          CONSTS.ON_READY = [];
        }

        document.addEventListener('DOMContentLoaded', _done);
        window.addEventListener('load', _done);
      }
    }
  };

  this.dom.load = function (callback) {
    if (utils.dom.isLoaded()) {
      callback();
    } else {
      CONSTS.ON_LOAD.push(callback);

      if (CONSTS.IS_LOADED === false) {
        CONSTS.IS_LOADED = 'loading';

        function _done() {
          CONSTS.IS_LOADED = true;
          utils.each(CONSTS.ON_LOAD, function (c) {
            c();
          });
          CONSTS.ON_LOAD = [];
        }

        window.addEventListener('load', _done);
      }
    }
  };

  // getter ------------------------------------------------------------------
  this.dom.get = function (selector, args) {
    args = (utils.is.element(args) ? { context: args } : args) || {};
    args.single = 'single' in args ? args.single : true;
    args.includeContext = 'includeContext' in args ? args.includeContext : false;
    args.onlyElements = 'onlyElements' in args ? args.onlyElements : false;

    var context = 'context' in args ? args.context : document;
    if (!Array.isArray(context)) {
      context = [context];
    }

    var elements = [];
    var contexts = [];
    var i = 0,
      l = context.length,
      ctx,
      children;

    // validate the contexts
    for (; i < l; ++i) {
      ctx = context[i];

      if (ctx && !utils.is.dom(ctx)) {
        ctx = utils.dom.get(ctx);
      }

      if (!ctx) continue;

      contexts.push(ctx);

      // include the current context if it's the same thing as the selector
      if (args.includeContext && utils.el.is(ctx, selector)) {
        elements.push(ctx);
      }
    }

    // domElement
    if (utils.is.dom(selector)) {
      elements.push(selector);
      // nodeElement
    } else if (utils.is.node(selector)) {
      elements.push(args.onlyElements ? selector.parentNode : selector);
      // jQuery or other types of Query
    } else if (utils.is.query(selector)) {
      elements = elements.concat(utils.toArray(selector));
      // create html from object
    } else if (utils.is.obj(selector, true)) {
      var node = utils.dom.create(selector);
      elements.push(node);
      // create html from string
    } else if (utils.is.str(selector) && selector.trim()[0] === '<') {
      var f = document.createElement('div');
      f.innerHTML = selector;
      children = utils.toArray(f.children, {
        map: function (c) {
          c.parentNode.removeChild(c);
        },
      });
      elements = elements.concat(children);
      // find elements by string OR function
    } else if (utils.is.either(selector, 'string,function')) {
      i = 0;
      l = contexts.length;

      var attr;
      for (; i < l; ++i) {
        ctx = contexts[i];
        children = [];

        try {
          if (utils.is.fn(selector)) {
            els = selector.call(ctx, ctx);
          } else if (ctx && utils.is.fn(ctx.querySelectorAll)) {
            // scope fix (add a custom attribute as a prefix) @polyfill https://github.com/jonathantneal/element-qsa-scope/blob/master/index.js
            if (ctx !== document) {
              attr = utils.string.random('attr');
              ctx.setAttribute(attr, '');

              children = ctx.querySelectorAll('[' + attr + '] ' + selector);
              ctx.removeAttribute(attr);
            } else {
              children = ctx.querySelectorAll(selector);
            }
          }
        } catch (e) {
          children = [];
        }

        children = utils.toArray(children);
        elements = elements.concat(children);
      }
      // is an array
    } else if (utils.is.enumerable(selector)) {
      i = 0;
      l = selector.length;

      for (; i < l; ++i) {
        children = utils.dom.getAll(selector[i], { context: args.contexts, onlyElements: args.onlyElements });
        elements = elements.concat(children);
      }
    }

    if (args.single) {
      return elements[0];
    } else {
      return utils.toArray(elements);
    }
  };

  this.dom.getAll = function (selector, args) {
    args = (utils.is.dom(args) ? { context: args } : args) || {};
    args.single = false;
    return utils.dom.get(selector, args);
  };

  // validation --------------------------------------------------------------
  this.dom.is = function (el, selector) {
    if (!el) return false;

    el = utils.dom.get(el);

    if (el === selector) {
      return true;
    } else if (utils.is.fn(selector)) {
      return !!selector(el);
    } else if (utils.is.string(selector)) {
      var match =
        el.matches ||
        el.matchesSelector ||
        el.msMatchesSelector ||
        el.mozMatchesSelector ||
        el.webkitMatchesSelector ||
        el.oMatchesSelector;
      var value = false;

      try {
        value = match && match.call(el, selector);
      } catch (e) {
        // @info in IE11 and less, a selector starting with a dash isnt valid (eg.: classname "-test" will break)
      }

      return value;
    } else if (utils.is.dom(selector)) {
      var compare = utils.dom.get(selector);
      // check if the element is the same OR if both ar Dom Roots (document, body, html)
      return el === compare; // || (utils.is.dom(selector, true) && utils.is.dom(compare, true));
    } else {
      return false;
    }
  };

  this.dom.contains = function (el, child) {
    child = utils.dom.get(child);
    return el && child && el.contains(child);
  };

  // manipulate --------------------------------------------------------------
  this.dom.add = function (el, position, selector) {
    if (selector === undefined) {
      selector = position;
      position = null;
    }
    if (utils.is.invalid(position)) {
      position = 'append';
    }

    var target = utils.dom.get(selector);
    if (!target) return;

    var parent = target.parentNode;
    var frag = null;

    if (el instanceof DocumentFragment) {
      frag = el;
    } else {
      frag = document.createDocumentFragment();
      el = utils.dom.getAll(el);

      var i = 0,
        l = el.length;
      for (; i < l; ++i) {
        frag.appendChild(el[i]);
      }
    }

    // keep the first element for return
    el = frag.childNodes[0];

    if (parent) {
      if (position === 'before') {
        parent.insertBefore(frag, target);
      } else if (position === 'after') {
        parent.insertBefore(frag, target.nextSibling);
      } else if (position === 'replace') {
        parent.insertBefore(frag, target);
        parent.removeChild(target);
      } else if (position === 'wrap') {
        parent.insertBefore(frag, target);
      }
    }

    if (position === 'wrap') {
      var deep = el;
      while (deep.children.length) {
        deep = deep.children[0];
      }
      deep.appendChild(target);
    } else if (position === 'prepend') {
      target.insertBefore(frag, target.childNodes[0]);
    } else if (position === 'append') {
      target.appendChild(frag);
    } else if (utils.is.nbr(position)) {
      if (target.childNodes[position]) {
        target.insertBefore(frag, target.childNodes[position].nextSibling);
      } else {
        target.appendChild(frag);
      }
    }

    return el;
  };

  this.dom.remove = function (els) {
    var isSingle = false;

    if (!(els instanceof Array)) {
      els = [els];
      isSingle = true;
    }

    var i = 0,
      l = els.length;
    for (; i < l; ++i) {
      if (els[i].parentNode) {
        els[i].parentNode.removeChild(els[i]);
      }
    }

    return isSingle ? els[0] : els;
  };

  this.dom.empty = function (el) {
    while (el.childNodes.length) {
      el.removeChild(el.childNodes[0]);
    }
    return el;
  };

  this.dom.clone = function (el, args) {
    if (utils.is.nbr(args)) {
      args = { times: args };
    } else if (utils.is.bool(args)) {
      args = { events: args, cache: args };
    }

    args = args || {};
    args.times = 'time' in args ? args.time : null;
    args.events = args.events || false;
    args.cache = args.cache || false;
    args.deep = 'deep' in args ? args.deep : true;

    var clones = [];
    var times = args.times === null ? 1 : args.time;

    utils.each(times, function () {
      var clone = el.cloneNode(args.deep);

      if (args.events) {
        // @nicetohave
      }
      if (args.cache) {
        // @nicetohave
      }

      clones.push(clone);
    });

    return args.times === null ? clones[0] : clones;
  };

  // find --------------------------------------------------------------------
  this.dom.children = function (el, args) {
    if (utils.is.bool(args)) {
      args = { text: args };
    }

    args = args || {};
    args.text = 'text' in args ? args.text : false;

    var children = [];
    if (el.children && !args.text) {
      children = el.children || [];
    } else {
      var nodes = el.childNodes;
      var children = [];
      var i = 0,
        node;
      while ((node = nodes[i++])) {
        if (node.nodeType === 1 || (args.text && node.nodeType === 3)) {
          children.push(node);
        }
      }
    }

    return utils.toArray(children);
  };

  this.dom.closest = function (el, selector, untilSelector) {
    var isFound = false;
    var untilParent = utils.dom.get(untilSelector);

    // check first if it's not already out of bounds
    if (untilParent && untilParent !== el && !utils.dom.contains(untilParent, el)) {
      return null;
    }

    while (el && !isFound) {
      if (utils.dom.is(el, selector)) {
        isFound = true;
      }
      if (isFound || el === untilParent) {
        break;
      }
      el = el.parentNode;
    }

    return isFound ? el : null;
  };

  this.dom.scrollParent = function (el, args) {
    args = args || {};
    args.direction = 'direction' in args ? args.direction : 'any';
    args.hasScroll = 'hasScroll' in args ? args.hasScroll : false;

    var parent = null;
    var style, oWidth, sWidth, cWidth, oHeight, sHeight, cHeight, isScrollWidth, isScrollHeight;

    while (el && !parent) {
      if (utils.is.dom(el, true)) break;

      style = utils.is.el(el) ? window.getComputedStyle(el) : null;
      oWidth = style ? style.getPropertyValue('overflow-x') : null;
      sWidth = el.scrollWidth;
      cWidth = el.clientWidth;
      oHeight = style ? style.getPropertyValue('overflow-y') : null;
      sHeight = el.scrollHeight;
      cHeight = el.clientHeight;
      isScrollWidth = oWidth === 'scroll' || (oWidth === 'auto' && (!args.hasScroll || sWidth > cWidth));
      isScrollHeight = oHeight === 'scroll' || (oHeight === 'auto' && (!args.hasScroll || sHeight > cHeight));

      if (
        (args.direction === 'any' && (isScrollWidth || isScrollHeight)) ||
        (args.direction === 'both' && isScrollWidth && isScrollHeight) ||
        (args.direction === 'vertical' && isScrollHeight) ||
        (args.direction === 'horizontal' && isScrollWidth)
      ) {
        parent = el;
      }

      el = el.parentNode;
    }

    if (!parent) {
      parent = window;
    }

    return parent;
  };

  // create/edit -------------------------------------------------------------
  this.dom.create = function (tag, args) {
    if (utils.is.object(tag, true)) {
      args = tag;
      tag = '';
    } else if (utils.is.either(args, 'string,number')) {
      args = { html: args };
    }
    args = args || {};
    args.tag = args.tag || tag || 'div';

    if (args.tag === true) {
      return document.createDocumentFragment();
    }

    var el = document.createElement(args.tag);
    utils.dom.update(el, args);

    return el;
  };

  this.dom.update = function (el, args) {
    args = args || {};
    args.parent = args.parent || null;
    args.classname = utils.toArray(utils.defined(args.classname, args.classnames, args.class, null));
    args.props = args.props || null;
    args.attrs = args.attrs || null;
    args.style = args.style || null;
    //args.events     = args.events || null; // not done yet
    args.data = args.data || null;
    args.html = utils.defined(args.html, null);
    args.alias = args.alias || '';

    if (args.classname !== null) utils.dom.classnames(el, args.classname, args.alias);
    if (args.props !== null) utils.dom.props(el, args.props);
    if (args.attrs !== null) utils.dom.attrs(el, args.attrs);
    if (args.style !== null) utils.dom.style(el, args.style);
    if (args.html !== null) utils.dom.html(el, args.html, { alias: args.alias });

    if (args.data) {
      el.data = utils.extend(el.data || {}, args.data);
    }

    var parent = utils.dom.get(args.parent);
    if (parent) {
      parent.appendChild(el);
    }

    return el;
  };

  // classname ---------------------------------------------------------------
  function toClassname(el, name, alias) {
    if (utils.is.fn(name)) {
      name = name(el, el.getAttribute('class'));
    }
    name = (name || '').toString().trim();
    return alias ? name.replace(/\&/g, alias) : name;
  }

  this.dom.classnames = function (el, classnames, alias) {
    function _get() {
      var cls = el.getAttribute('class') || '';
      cls = utils.toArray(cls, { separator: ' ', unique: true });
      return cls;
    }

    // getter
    if (classnames === undefined) {
      return _get();
    }

    // setter
    var classnames = utils.is.str(classnames) ? utils.toArray(classnames, ' ') : classnames;
    var unique = [];
    var i, c, idx, add;

    if (utils.is.obj(classnames, true)) {
      var old = _get();
      for (i in old) {
        c = old[i];
        if (c in classnames) continue;
        classnames[c] = true;
      }
    }

    for (i in classnames) {
      add = true;
      c = classnames[i];

      if (utils.is.bool(c)) {
        add = c;
        c = i;
      }

      c = toClassname(el, c, alias);
      idx = unique.indexOf(c);

      if (add && !~idx) {
        unique.push(c);
      } else if (!add && ~idx) {
        unique.splice(idx, 1);
      }
    }

    classnames = unique.join(' ');

    if (classnames) {
      el.setAttribute('class', classnames);
    } else {
      el.removeAttribute('class');
    }

    return el;
  };

  this.dom.classnames.add = function (el, classnames, alias, duration) {
    var current = utils.dom.classnames(el);
    var old = current.toString();
    var i, c;

    classnames = utils.toArray(classnames, ' ');

    for (i in classnames) {
      c = toClassname(el, classnames[i], alias);
      current.push(c);
    }

    // duration
    duration = utils.string.toDuration(duration);
    if (duration) {
      setTimeout(function () {
        utils.dom.classnames(el, old);
      }, duration);
    }

    return utils.dom.classnames(el, current);
  };

  this.dom.classnames.remove = function (el, classnames, alias) {
    var current = utils.dom.classnames(el);
    var i, c;

    classnames = utils.toArray(classnames, ' ');

    for (i in classnames) {
      c = toClassname(el, classnames[i], alias);
      utils.array.remove(current, c);
    }

    return utils.dom.classnames(el, current);
  };

  this.dom.classnames.toggle = function (el, classnames, alias) {
    var current = utils.dom.classnames(el);
    var i, c, idx;

    classnames = utils.toArray(classnames, ' ');

    for (i in classnames) {
      c = toClassname(el, classnames[i], alias);
      idx = current.indexOf(c);

      if (!~idx) {
        current.push(c);
      } else {
        current.splice(idx, 1);
      }
    }

    return utils.dom.classnames(el, current);
  };

  // props -------------------------------------------------------------------
  CONSTS.PX_VALUES = [
    'top',
    'right',
    'bottom',
    'left',
    'height',
    'width',
    'min-height',
    'max-height',
    'min-width',
    'max-width',
    'border-top',
    'border-right',
    'border-bottom',
    'border-left',
    'border-top-width',
    'border-right-width',
    'border-bottom-width',
    'border-left-width',
    'border-radius',
    'border-spacing',
    'background-size',
    'background-position', // @note do not put "background" in this, espacially when using rgba()
    'margin',
    'margin-top',
    'margin-right',
    'margin-bottom',
    'margin-left',
    'padding',
    'padding-top',
    'padding-right',
    'padding-bottom',
    'padding-left',
    'font-size',
  ];

  RE.CSS_NUMBER = /((?:^|\s|\()\-?[0-9]+(?:\.[0-9]+(?:e-[0-9]+)?)?(?=\)|\s|$))/g;

  function to4BoxValues(s, p) {
    var d = ['top', 'right', 'bottom', 'left'];
    var vls = [];
    var i = 0,
      l = d.length,
      k,
      v;

    for (; i < l; ++i) {
      k = p.replace('{direction}', d[i]);
      v = parseFloat(s[k] || 0);
      vls.push(v);
    }

    vls.vertical = vls[0] + vls[2];
    vls.horizontal = vls[1] + vls[3];

    return vls;
  }

  this.dom.props = function (el, key, value) {
    var values = utils.toSet(key, value);
    if (values) {
      var i;
      for (i in values) {
        if (utils.is.fn(el[i])) {
          el[i].apply(null, values[i]);
        } else {
          el[i] = values[i];
        }
      }
    } else if (key) {
      return el[key];
    } else {
      return null;
    }
  };

  this.dom.attrs = function (el, key, value) {
    var values = utils.toSet(key, value);
    if (values) {
      var i, v;
      for (i in values) {
        v = values[i];
        if (utils.is.not(v)) {
          el.removeAttribute(i);
        } else {
          el.setAttribute(i, v === true ? '' : v);
        }
      }
    } else if (key) {
      return el.getAttribute(key);
    } else {
      values = {};

      var i = 0,
        l = el.attributes.length,
        k,
        v;
      for (; i < l; ++i) {
        k = el.attributes[i].name.toString();
        v = el.attributes[i].value.toString();
        values[k] = v;
      }

      return values;
    }
  };

  this.dom.data = function (el, key, value) {
    var values = utils.toSet(key, value);
    if (values) {
      var n, v;
      for (n in values) {
        v = values[n];
        n = 'data-' + utils.string.dash2camel(n);

        if (v === null) {
          el.removeAttribute(n);
        } else {
          el.setAttribute(n, v);
        }
      }
    } else {
      values = {};

      var i = 0,
        l = el.attributes.length,
        n,
        v;
      for (; i < l; ++i) {
        n = el.attributes[i].name.toString();
        v = el.attributes[i].value.toString();

        if (n.indexOf('data-') !== 0) continue;

        n = utils.string.dash2camel(n.replace('data-', ''));
        values[n] = utils.toValue(v, { json: true });
      }

      return key !== undefined ? values[key] : values;
    }
  };

  this.dom.style = function (el, key, value) {
    var values = utils.toSet(key, value);

    if (values) {
      var i, v, t, isVar;
      for (i in values) {
        isVar = i.indexOf('--') === 0;
        v = values[i] === null ? '' : values[i];
        t = typeof v;

        // add the PX to the numbers (if no unit has been set)
        if ((t === 'number' || t === 'string') && !!~CONSTS.PX_VALUES.indexOf(i)) {
          v = v.toString().replace(RE.CSS_NUMBER, function (m, $1) {
            return $1 + 'px';
          });
        }

        if (isVar) {
          el.style.setProperty(i, v);
        } else {
          el.style[i] = v;
        }
      }
    } else {
      var style = el.style ? window.getComputedStyle(el) : {};
      var isVar = utils.is.fn(style.getPropertyValue) && utils.is.str(key) && key.indexOf('--') === 0;

      if (isVar) {
        return style.getPropertyValue(key).trim();
      } else if (key in style) {
        return style[key];
      } else if (utils.is.defined(key)) {
        return null;
      } else {
        var i,
          values = {};
        for (i in style) {
          if (!isNaN(i)) continue;
          values[i] = style[i];
        }
        return values;
      }
    }
  };

  this.dom.html = function (el, html, args) {
    if (html === undefined) {
      return (el.innerHTML || '').trim();
    }

    args = args || {};
    args.alias = args.alias || '';

    if (utils.is.obj(html)) {
      var f = document.createDocumentFragment();
      var n = Array.isArray(html) ? html : [html];
      var i = 0,
        l = n.length,
        h,
        c;

      for (; i < l; ++i) {
        h = n[i];

        if (utils.is.object(h, true)) {
          // make sure the alias propagate
          if (!('alias' in n[i]) && args.alias) {
            n[i].alias = args.alias;
          }
          c = utils.dom.create(n[i]);
        } else if (utils.is.node(h)) {
          c = h;
        } else if (utils.is(h)) {
          c = document.createTextNode(h.toString());
        } else {
          c = null;
        }

        if (c !== null) {
          f.appendChild(c);
        }
      }

      utils.dom.empty(el);
      el.appendChild(f);
    } else {
      el.innerHTML = html;
    }
  };

  this.dom.val = function (el, value, data) {
    if (value === undefined) {
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (el.checked) {
          value = el.hasAttribute('value') ? el.value : true;
        } else {
          value = false;
        }
      } else if (el.hasAttribute('contenteditable')) {
        value = el.innerHTML;
      } else if (el.tagName.toLowerCase() === 'select') {
        var values = [];
        var options = el.options;
        var i = 0,
          l = options.length,
          option;

        for (; i < l; ++i) {
          option = options[i];

          if (option.selected) {
            values.push(option.value);
          }
        }

        if (el.multiple) {
          value = values;
        } else {
          value = values[0] === undefined ? -1 : values[0];
        }
      } else {
        value = el.value;
      }

      if (utils.is.str(value)) {
        value = value.trim();
      }

      return utils.toValue(value);
    } else {
      if (el.type === 'radio' || el.type === 'checkbox') {
        if (value instanceof Array) {
          // the indexOf needs to be compared with strings
          el.checked = !!~value.join().split(',').indexOf(el.value);
        } else if (el.hasAttribute('value')) {
          el.checked = el.value == value;
        } else {
          el.checked = !!value;
        }
      } else if (el.tagName.toLowerCase() === 'select') {
        var options = el.options || [];
        var values = value instanceof Array ? value : [value];
        var isSet = false;
        var i = 0,
          l = options.length,
          option;

        for (; i < l; ++i) {
          option = options[i];

          if (~values.indexOf(option.value)) {
            option.selected = true;
            isSet = true;
          } else {
            option.selected = false;
          }
        }

        if (!isSet) {
          el.selectedIndex = -1;
        }
      } else {
        if (utils.is.str(value)) {
          value = utils.string.replace(value, data);
        } else if (typeof value === 'object') {
          value = JSON.stringify(value);
        }

        if (el.hasAttribute('contenteditable')) {
          el.innerHTML = value;
        } else {
          el.value = value;
        }
      }
    }
  };

  this.dom.values = function (el, key, value, setter) {
    /*
		values($0);									// get all
		values($0, function (){});					// get all + getter
		values($0, 'name', function (){});			// get one + getter
		values($0, 'name', 'value');				// set 1
		values($0, {});								// set those
		values($0, {}, function (){});				// set those + setter
		values($0, 'name', 'value', function (){}); // set 1 + setter;
		*/

    var getter = null;
    if (utils.is.fn(key)) {
      getter = key;
      setter = null;
      key = undefined;
    } else if (utils.is.str(key) && utils.is.fn(value)) {
      getter = value;
      value = undefined;
    } else if (utils.is.obj(key) && utils.is.fn(value)) {
      setter = value;
      value = undefined;
    }

    var inputs = utils.dom.getAll('input,textarea,select,[contenteditable]', { context: el });
    var values = utils.toSet(key, value);
    var isSet = !!values;
    var toggles = {};

    if (!getter) getter = utils.fn.empty;
    if (!setter) setter = utils.fn.empty;
    if (!isSet) values = [];

    var i = 0,
      l = inputs.length;
    //var input, name, isSkipped, value, type;
    for (; i < l; ++i) {
      var input = inputs[i];
      var name = input.getAttribute('name');
      var isSkipped = input.hasAttribute('skip');

      if (!name || !name.trim() || isSkipped) continue;

      var type = input.hasAttribute('contenteditable') ? 'html' : input.tagName.toLowerCase();
      if (type === 'input') {
        type = input.type || 'text';
      }

      var isArray = !!name.match(/\[\]$/);
      var isToggle = type === 'checkbox' || type === 'radio';
      var basename = name.replace(/\[\]$/, '');

      // setter ----------------------------------------------------------
      if (isSet) {
        name = name.replace(/\[\]$/, '');
        value = setter(values[name], name, input, values);

        // alernate name (if input name="item[val]")
        if (value === undefined) {
          alt = utils.string.match(name, /^([^\[]+)\[(.+)\]$/);

          if (alt.length === 2 && values[alt[0]]) {
            name = alt[0];
            value = setter(values[name][alt[1]], name, input, values);
          }
        }

        if (value === undefined) continue;

        if (value === null) {
          value = '';
        }

        if (isArray && !utils.is.arr(value)) {
          value = [value];
        }

        utils.dom.val(input, value);
        // getter ----------------------------------------------------------
      } else {
        // skip hidden that are checked
        if (type === 'hidden' && input.checked) {
          continue;
        }

        value = utils.dom.val(input);

        if (isToggle && !toggles[name]) {
          // default values
          if (isArray) {
            values.push([basename, []]);
          } else {
            values.push([name, false]);
          }
          toggles[name] = true;
        }

        var isValid = utils.is(value);

        if ((isArray && isValid) || (!isArray && type === 'radio' && isValid) || (!isArray && type !== 'radio')) {
          value = getter(value, name, input);
          values.push([name, value]);
        }
      }
    }

    // format the values gotten from the fields into a object
    if (!isSet) {
      values = utils.object.namespace(values, { separator: 'form', arraySets: true });
    }

    return key ? values[key] : values;
  };

  this.dom.index = function (el, parentSelector) {
    var children = parentSelector ? utils.dom.getAll(parentSelector) : utils.toArray(el.parentNode.children);
    return children.indexOf(el);
  };

  this.dom.bounds = function (el, args) {
    if (utils.is.bool(args)) {
      args = { scrollParent: args };
    }

    args = args || {};
    args.offsetX = args.offsetX || 0;
    args.offsetY = args.offsetY || 0;
    args.scrollParent = args.scrollParent || false;

    if (el !== window && utils.is.dom(el, true)) {
      el = document.body;
    }

    var bounds = {
      node: el,
      visible: utils.dom.isVisible(el),
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      centerX: 0,
      centerY: 0,
      padding: [0, 0, 0, 0],
      border: [0, 0, 0, 0],
      margin: [0, 0, 0, 0],
      center: null,
      scale: 0,
      scrollTop: 0,
      scrollLeft: 0,
      scrollHeight: 0,
      scrollWidth: 0,
      scrollParent: null,
      viewportBox: null,
      paddingBox: null,
      borderBox: null,
      marginBox: null,
    };

    bounds.padding.horizontal = bounds.padding.vertical = 0;
    bounds.border.horizontal = bounds.border.vertical = 0;
    bounds.margin.horizontal = bounds.margin.vertical = 0;

    // find dimension of text node
    if (el === window) {
      bounds.width = window.innerWidth;
      bounds.height = window.innerHeight;
    } else if (el && el.nodeType === 3) {
      var range, rect, r;

      range = document.createRange();
      range.selectNodeContents(el);
      rect = range.getClientRects();

      bounds.left = Infinity;
      bounds.top = Infinity;

      var i = 0,
        l = rect.length,
        r;
      for (; i < l; ++i) {
        r = rect[i];
        bounds.left = Math.min(r.left, bounds.left);
        bounds.top = Math.min(r.top, bounds.top);
        bounds.width = Math.max(r.width, bounds.width);
        bounds.height = Math.max(r.height, bounds.height);
      }
    } else if (el && bounds.visible) {
      var s = window.getComputedStyle(el);
      var b = el.getBoundingClientRect();
      bounds.left = b.left;
      bounds.top = b.top;
      bounds.width = b.width;
      bounds.height = b.height;
      bounds.padding = to4BoxValues(s, 'padding-{direction}');
      bounds.border = to4BoxValues(s, 'border-{direction}-width');
      bounds.margin = to4BoxValues(s, 'margin-{direction}');
    }

    // @info clientWidth/Height doesn't return floating points, so there's never any decimals (use getBoudingClientRect() for the real data)
    var x = 0,
      y = 0,
      h = 0,
      w = 0;
    if (el && bounds.visible) {
      x = bounds.left; // this is the x with the border
      y = bounds.top; // this is the y with the border
      h = el.clientHeight || bounds.height || 0; // this is the inner height without the border
      w = el.clientWidth || bounds.width || 0; // this is the inner width without the border

      x += args.offsetX;
      y += args.offsetY;

      var p = args.scrollParent && utils.is.node(el) ? utils.dom.scrollParent(el, { hasScroll: false }) : window;
      if (p !== window) {
        var pb = p.getBoundingClientRect();
        x += p.scrollLeft - pb.left;
        y += p.scrollTop - pb.top;
        bounds.scrollParent = p;
      } else {
        x += window.scrollX || window.pageXOffset || 0;
        y += window.scrollY || window.pageYOffset || 0;
      }
    }

    var b = utils.toBounds([x, y, w, h], {
      padding: bounds.padding,
      offsetX: bounds.border[3],
      offsetY: bounds.border[0],
    });
    var pBox = utils.toBounds(b, { margin: bounds.padding });
    var bBox = utils.toBounds(pBox, { margin: bounds.border });
    var mBox = utils.toBounds(bBox, { margin: bounds.margin });
    var vBox = utils.toBounds([bounds.left, bounds.top, bounds.width, bounds.height]);

    bounds.x = b.x;
    bounds.y = b.y;
    bounds.width = b.width;
    bounds.height = b.height;
    bounds.top = b.top;
    bounds.right = b.right;
    bounds.bottom = b.bottom;
    bounds.left = b.left;
    bounds.centerX = b.centerX;
    bounds.centerY = b.centerY;
    bounds.center = b.center;

    bounds.paddingBox = pBox;
    bounds.borderBox = bBox;
    bounds.marginBox = mBox;
    bounds.viewport = vBox; // this consider the transform:scale()

    if (el) {
      bounds.scale = Math.round(bounds.width) / el.offsetWidth || 1;
      bounds.scrollTop = el.scrollTop || 0;
      bounds.scrollLeft = el.scrollLeft || 0;
      bounds.scrollHeight = el.scrollHeight !== el.clientHeight ? el.scrollHeight : 0;
      bounds.scrollWidth = el.scrollWidth !== el.clientWidth ? el.scrollWidth : 0;
    }

    return bounds;
  };

  this.dom.scroll = function (el, key) {
    var isRoot = !utils.is.el(el);

    var data = {
      node: el,
      x: 0,
      y: 0,
      top: isRoot ? window.pageYOffset : el.scrollTop,
      right: 0,
      bottom: 0,
      left: isRoot ? window.pageXOffset : el.scrollLeft,
      width: isRoot ? document.documentElement.scrollWidth : el.scrollWidth,
      height: isRoot ? document.documentElement.scrollHeight : el.scrollHeight,
      clientWidth: isRoot ? document.documentElement.clientWidth : el.offsetWidth,
      clientHeight: isRoot ? document.documentElement.clientHeight : el.offsetHeight,
      maxX: 0,
      maxY: 0,
      ratioX: 0,
      ratioY: 0,
      isStartX: false,
      isStartY: false,
      isEndX: false,
      isEndY: false,
      isStart: false,
      isEnd: false,
    };

    data.x = data.left;
    data.y = data.top;
    data.bottom = data.top + data.clientHeight;
    data.right = data.left + data.clientWidth;
    data.maxX = data.width - data.clientWidth - (isRoot ? 0 : 1);
    data.maxY = data.height - data.clientHeight - (isRoot ? 0 : 1);
    data.ratioX = utils.clamp(Math.round(data.left) / data.maxX) || 0;
    data.ratioY = utils.clamp(Math.round(data.top) / data.maxY) || 0;
    data.hasScrollX = data.maxX > 0;
    data.hasScrollY = data.maxY > 0;
    data.isStartX = data.left === 0;
    data.isStartY = data.top === 0;
    data.isEndX = data.ratioX === 1 || data.width <= data.clientWidth;
    data.isEndY = data.ratioY === 1 || data.height <= data.clientHeight;
    data.isStart = data.isStartX && data.isStartY;
    data.isEnd = data.isEndX && data.isEndY;

    return key ? data[key] : data;
  };

  // display/transitions -----------------------------------------------------
  CONSTS.DISPLAYS = {};

  this.dom.isVisible = function (el) {
    return el && !!(el.offsetWidth || el.offsetHeight || (el.getClientRects && el.getClientRects().length));
  };

  this.dom.show = function (el) {
    //var tag = utils.dom.tag(el);
  };

  this.dom.hide = function (el) {};

  this.dom.flip = function (els, args) {
    if (!utils.is.arr(els)) {
      els = [els];
    }

    if (utils.is.str(args)) {
      args = { classname: args };
    } else if (utils.is.fn(args)) {
      args = { onEach: args };
    }

    args = args || {};
    args.classname = args.classname || ''; // toggle classname
    args.onEach = args.onEach || args.callback || null; // function to call (on each element) when we saved the element to transition
    args.onStart = args.onStart || null; // function called after saving all the current props of the element
    args.onComplete = args.onComplete || null;
    args.context = args.context || null;
    args.translate = args.translate || false; // transition the element from where it was to it's final position
    args.scale = args.scale || false; // scale the element
    args.props = args.props || null; // props to transition, if true, find all the difference
    args.clear = 'clear' in args ? args.clear : true;
    args.duration = args.duration || 500;
    args.easing = args.easing || 'ease-in-out'; // css easing

    var cacheKey = 'flip-transition';
    var props = null;
    var items = [];
    var isComplete = false;

    function _clean(item) {
      if (args.clear) {
        item.el.style = item.style;

        if (props) {
          for (var i in props) {
            // if the 3 value is true, then you keep that value in "TO" the style, or a set value
            if (props[i][2] !== undefined) {
              item.el.style[i] = props[i][2] === true ? item.to.props[i] : props[i][2];
            }
          }
        }
      } else {
        item.el.style.transform = '';
        item.el.style.transition = '';
      }
      clearTimeout(item.timeout);

      item.el[cacheKey] = null;
    }

    function _complete() {
      if (isComplete) return;
      isComplete = true;

      var i = 0,
        l = items.length;
      for (; i < l; ++i) {
        _clean(items[i]);
      }

      utils.apply(args.onComplete, els, args.context);
    }

    // find the props (if specified)
    if (args.props) {
      props = {};
    }
    utils.each(args.props, function (v, i, a) {
      if (a.type !== 'object') {
        i = v;
        v = true; // true means use the current value
      }

      if (!Array.isArray(v)) {
        v = [v, v];
      }

      props[i] = v;
    });

    // (F)irst - save the positions ----------------------------------------
    var i, ii, l, el, b, item, s, v;

    ((i = 0), (l = els.length));
    for (; i < l; ++i) {
      el = els[i];
      item = {
        el: el,
        index: i,
        timeout: null,
        from: { x: 0, y: 0, w: 0, h: 0, props: {} },
        to: { x: 0, y: 0, w: 0, h: 0, props: {} },
        style: '',
      };

      if (props) {
        s = window.getComputedStyle(el);
        for (ii in props) {
          v = props[ii][0];
          v = v === true ? s[ii] : v;
          item.from.props[ii] = v;
        }
      }

      b = utils.dom.bounds(el);
      item.from.x = b.left;
      item.from.y = b.top;
      item.from.w = b.right - b.left;
      item.from.h = b.bottom - b.top;

      if (props) {
        if (props.height && props.height[0] === true) {
          item.from.props.height = item.from.h + 'px';
        }
        if (props.width && props.width[0] === true) {
          item.from.props.width = item.from.w + 'px';
        }
      }

      // clear the current animation
      if (el[cacheKey]) {
        _clean(el[cacheKey]);
      }

      // cache the inline style and the current transition
      item.style = el.style.cssText;
      el[cacheKey] = item;

      items.push(item);
    }

    // (L)ast - change the props -------------------------------------------
    utils.apply(args.onStart, [els, items]);

    ((i = 0), (l = items.length));
    for (; i < l; ++i) {
      item = items[i];

      if (args.classname) {
        utils.dom.toggleClass(item.el, args.classname);
      }

      // set FROM props
      if (props) {
        s = window.getComputedStyle(el);

        for (ii in props) {
          v = props[ii][1];
          v = v === true ? s[ii] : v;
          item.to.props[ii] = v;
          el.style[ii] = v;
        }
      }

      utils.apply(args.onEach, [item.el, item], args.context);
    }

    // (I)nverse -----------------------------------------------------------
    var dx, dy, sw, sh, t;
    ((i = 0), (l = items.length));
    for (; i < l; ++i) {
      item = items[i];
      el = item.el;
      b = utils.dom.bounds(item.el);
      item.to.x = b.left;
      item.to.y = b.top;
      item.to.w = b.right - b.left;
      item.to.h = b.bottom - b.top;

      // deal with transform (translate and scale)
      dx = item.from.x - item.to.x;
      dy = item.from.y - item.to.y;
      sw = item.from.w / item.to.w;
      sh = item.from.h && item.to.h ? item.from.h / item.to.h : item.to.h ? 1 : 0;

      t = [];
      if (args.translate && (dx || dy)) {
        t.push('translate(' + dx + 'px, ' + dy + 'px)');
      }
      if (args.scale && (sw !== 1 || sh !== 1)) {
        t.push('scale(' + sw + ', ' + sh + ')');
      }
      t = t.join(' ');

      el.style.transition = 'none';

      if (t) {
        el.style.transform = t;
        el.style.transformOrigin = 'top left';
      }

      // set FROM props
      if (props) {
        for (ii in props) {
          v = props[ii][1];

          if (v === true || v === '') {
            if (ii === 'height') {
              item.to.props.height = item.to.h + 'px';
            } else if (ii === 'width') {
              item.to.props.width = item.to.w + 'px';
            }
          }

          el.style[ii] = item.from.props[ii];
        }
      }
    }

    // (P)lay --------------------------------------------------------------
    utils.fn.requestFrame(function () {
      var transition = 'all ' + args.duration + 'ms ' + args.easing;
      var timeout = setTimeout(_complete, args.duration);
      var i = 0,
        l = items.length,
        ii;

      for (; i < l; ++i) {
        item = items[i];
        item.timeout = timeout;

        item.el.style.transition = transition;
        item.el.style.transform = '';

        if (props) {
          for (ii in item.to.props) {
            el.style[ii] = item.to.props[ii];
          }
        }
      }
    });
  };

  this.dom.scrollTo = function (el, args) {
    if (utils.is.arr(args)) {
      args = { x: args[0], y: args[1] };
    }

    args = args || {};
    args.x = 'x' in args ? args.x : null;
    args.y = 'y' in args ? args.y : null;
    args.duration = 'duration' in args ? args.duration : 0;
    args.easing = args.easing || null;
    args.context = args.context || null;
    args.onComplete = args.callback || args.onComplete || null;
    args.scrollParent = args.scrollParent || false;

    // format
    args.duration = utils.string.toDuration(args.duration);

    if (args.scrollParent) {
      el = utils.el.scrollParent(el);
    }

    var isRoot = utils.is.dom(el, true);
    var from = { x: 0, y: 0 };
    var to = { x: args.x, y: args.y };

    // calculate the percent x/y
    if (utils.is.str(to.x) || utils.is.str(to.y) || args.duration) {
      var s = utils.dom.scroll(el);
      from.x = s.x;
      from.y = s.y;
      to.x = utils.calculate(to.x, s.maxX);
      to.y = utils.calculate(to.y, s.maxY);
    }

    function _scroll(x, y) {
      if (isRoot) {
        if (!utils.is.nbr(x)) x = window.pageXOffset;
        if (!utils.is.nbr(y)) y = window.pageYOffset;
        window.scrollTo(x, y);
      } else {
        if (!isNaN(x)) el.scrollLeft = x;
        if (!isNaN(y)) el.scrollTop = y;
      }
    }

    function _tick(r) {
      var x = from.x + (to.x - from.x) * r;
      var y = from.y + (to.y - from.y) * r;

      _scroll(x, y);

      r === 1 && _done();
    }

    function _done() {
      // clear the animation
      el._scrollAnimation = null;

      // action at the end
      utils.apply(args.onComplete, null, args.context);
    }

    if (el._scrollAnimation) {
      el._scrollAnimation.stop();
    }

    if (args.duration) {
      el._scrollAnimation = utils.animate({ duration: args.duration, easing: args.easing }, _tick);
    } else {
      _scroll(to.x, to.y);
      _done();
    }

    return el._scrollAnimation;
  };

  this.dom.scrollIntoView = function (el, args) {
    args = args || {};
    args.ratio = args.ratio || 0;
    args.duration = 'duration' in args ? args.duration : 1000;
    args.offset = args.offset || 0;
    args.easing = args.easing || null;
    args.fix = args.fix || false;
    args.context = args.context || null;
    args.onComplete = args.onComplete || null;

    //var parent = utils.dom.scrollParent(el);
    var bounds = utils.dom.bounds(el, true);
    var parent = bounds.scrollParent;

    if (!parent) {
      return console.warn("The element can't be scrolled into view, the parent can't be found (or is hidden)");
    }

    function _getScroll() {
      var bounds = utils.dom.bounds(el, true);
      var height = parent.clientHeight - bounds.height;
      var width = parent.clientWidth - bounds.width;
      var y = bounds.marginBox.top - args.ratio * height + args.offset;
      var x = bounds.marginBox.left - args.ratio * width + args.offset;

      return {
        x: x,
        y: y,
      };
    }

    function _complete() {
      if (args.fix) {
        var xy = _getScroll();
        parent.scrollTop = xy.y;
        parent.scrollLeft = xy.x;
      }

      utils.apply(args.onComplete, [], args.context);
    }

    var from = { y: parent.scrollTop, x: parent.scrollLeft };
    var to = _getScroll();

    if (parent._scrollAnimation) {
      parent._scrollAnimation.stop();
    }

    if (args.duration) {
      parent._scrollAnimation = utils.animate({ duration: args.duration, easing: args.easing }, function (r) {
        var y = from.y + (to.y - from.y) * r;
        var x = from.x + (to.x - from.x) * r;
        parent.scrollTop = y;
        parent.scrollLeft = x;

        if (r === 1) {
          _complete();
        }
      });
    } else {
      parent.scrollTop = to.y;
      parent.scrollLeft = to.x;
      _complete();
    }
  };

  // events ------------------------------------------------------------------
  RE.DELEGATE_EVENT = /([^:]+)\:(.+)/;
  RE.NAMESPACE_EVENT = /([^.]+)\.(.+)/;

  CONSTS.EVENTS = {};

  CONSTS.ALT_DELEGATE_EVENTS = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout',
    pointerenter: 'pointerover',
    pointerleave: 'pointerout',
  };

  CONSTS.EVENT_CLASSES = {
    click: 'MouseEvent',
    dblclick: 'MouseEvent',
    mouseover: 'MouseEvent',
    mouseout: 'MouseEvent',
    mouseenter: 'MouseEvent',
    mouseleave: 'MouseEvent',
    mousemove: 'MouseEvent',
    mousedown: 'MouseEvent',
    wheel: 'MouseEvent',
    select: 'MouseEvent',
    focus: 'FocusEvent',
    blur: 'FocusEvent',
    reset: 'Event',
    submit: 'Event',
    keydown: 'KeyboardEvent',
    keypress: 'KeyboardEvent',
    keyup: 'KeyboardEvent',
    change: 'Event',
    load: 'ProgressEvent',
  };

  CONSTS.CUSTOM_EVENTS = {};

  function toEvents(el, names, args, isRemove) {
    // multiple set of events
    if (utils.is.obj(names)) {
      var name, a;
      for (name in names) {
        a = names[name];

        if (utils.is.obj(a)) {
          a = utils.extend({}, args, a);
        } else if (utils.is.fn(a)) {
          a = utils.extend({}, args, { callback: a });
        }

        toEvents(el, name, a, isRemove);
      }
      return;
    }

    if (utils.is.fn(args) || utils.is.array(args)) {
      args = { callback: args };
    }

    args = args || {};
    args.callback = args.callback || null; // can be a function or an array of functions
    args.delegate = args.delegate || null; // sub-element delegation
    args.context = args.context || null;
    args.namespace = args.namespace || '';
    args.alias = args.alias || ''; // when event names uses the "&" it will be replaced by ".{name}...."
    args.capture = 'capture' in args ? args.capture : false;
    args.passive = 'passive' in args ? args.passive : null;
    args.once = 'once' in args ? args.once : false;

    utils.each(names, { separator: ' ', lowercase: true }, function (eName) {
      var eDelegate = args.delegate;
      var eNamespace = args.namespace;

      // refresh the eventname if the delegate is in it's name (eg.: .my-class:click)
      if (!!~eName.indexOf(':')) {
        var pair = utils.string.match(eName, RE.DELEGATE_EVENT);
        eName = pair[1];
        eDelegate = pair[0];
      }
      if (utils.is.string(eDelegate) && args.alias) {
        eDelegate = eDelegate.replace(/&/g, '.' + args.alias);
      }

      // check for namespaced event
      if (!!~eName.indexOf('.')) {
        var pair = utils.string.match(eName, RE.NAMESPACE_EVENT);
        eName = pair[0];
        eNamespace = pair[1];
      }

      // custom events (move complex)
      if (eName in CONSTS.CUSTOM_EVENTS) {
        var cEvent = CONSTS.CUSTOM_EVENTS[eName];

        if (!isRemove && utils.is.fn(cEvent.on)) {
          cEvent.on(el, eDelegate, args);
        } else if (isRemove && utils.is.fn(cEvent.off)) {
          cEvent.off(el, eDelegate, args);
        }

        return;
      }

      var oName = eName;
      var isAlt = oName in CONSTS.ALT_DELEGATE_EVENTS;
      eName = isAlt && eDelegate ? CONSTS.ALT_DELEGATE_EVENTS[oName] : oName;

      var cacheKey = [args.context, oName, eDelegate, eNamespace, args.callback, args.capture];
      var bind = utils.cache(CONSTS.EVENTS, cacheKey);

      if (!bind) {
        bind = function (e) {
          var target = e.target;
          var related = e.relatedTarget;
          var callback = args.callback;

          // find the right delegate target
          if (eDelegate) {
            target = utils.dom.closest(target, eDelegate);

            if (!target) {
              return;
            } else if (isAlt && (related === target || target.contains(related))) {
              return;
            } else if (!utils.dom.is(target, eDelegate)) {
              return;
            }
          } else {
            target = this;
          }

          var event = {
            originalEvent: e,
            originalTarget: e.target,
            originalType: e.type,
            type: eName,
            target: target,
            timestamp: new Date(),
            data: e.details || null,
            pageX: e.pageX,
            pageY: e.pageY,
            clientX: e.clientX,
            clientY: e.clientY,
            offsetX: e.offsetX,
            offsetY: e.offsetY,
            touches: e.touches,
            keyAlt: e.altKey,
            keyCtrl: e.ctrlKey,
            keyCommand: e.metaKey,
            keyWindow: e.metaKey,
            keyMeta: e.metaKey,
            key: e.key === undefined ? null : e.key,
            keyCode: e.keyCode === undefined ? null : e.keyCode,
            // functions -------------------------------------------
            preventDefault: function () {
              e.preventDefault();
              this.isDefaultPrevented = true;
            },
            stopPropagation: function () {
              e.stopPropagation();
              this.isPropagationStopped = true;
            },
            stopImmediatePropagation: function () {
              e.stopImmediatePropagation();
              this.isPropagationStopped = true;
            },
            stop: function () {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
            },
          };

          if (utils.is.fn(callback)) {
            callback.call(args.context || target, event);
          }

          // @nicetohave deal with multiple callbacks
        };
      }

      bind.eventname = eName;
      bind.namespace = eNamespace;
      bind.capture = args.capture;

      // cache the events
      var elEvents = utils.cache(el, '__EVENTS__') || [];
      var bindIndex = elEvents.indexOf(bind);
      var bindExists = !!~bindExists;

      if (bindExists && isRemove) {
        el.removeEventListener(bind.eventname, bind, {
          capture: args.capture,
          passive: args.passive,
          once: args.once,
        });

        utils.cache(CONSTS.EVENTS, cacheKey, null);
        elEvents.splice(bindIndex, 1);
      } else if (bindExists) {
        el.addEventListener(bind.eventname, bind, {
          capture: args.capture,
          passive: args.passive,
          once: args.once,
        });

        utils.cache(CONSTS.EVENTS, cacheKey, bind);
        elEvents.push(bind);
      }

      utils.cache(el, '__EVENTS__', elEvents);
    });
  }

  function addEvent(el, names, args) {
    toEvents(el, names, args);
  }

  function removeEvent(el, names, args) {
    // remove all events
    if (names === true) {
      var events = utils.cache(el, '__EVENTS__') || [];
      var namespace = utils.is.str(args) ? args : '';
      var keep = [];
      var i = 0,
        l = events.length,
        bind;

      for (; i < l; ++i) {
        bind = events[i];

        if (namespace && bind.namespace !== namespace) {
          keep.push(bind);
          continue;
        }

        el.removeEventListener(bind.eventname, bind, { capture: bind.capture });
      }

      utils.cache(el, '__EVENTS__', keep);
      utils.cache(el, '__EVENTS_BATCH__', {});
    } else {
      toEvents(el, names, args, true);
    }
  }

  function triggerEvent(el, names, args) {
    args = args || {};
    args.bubbles = 'bubbles' in args ? args.bubbles : true;
    args.cancelable = args.cancelable || false;
    args.details = args.details || args.data || {};

    utils.each(names, { separator: ' ', lowercase: true }, function (eventname) {
      // get the alternate delegate event
      if (eventname in CONSTS.ALT_DELEGATE_EVENTS) {
        eventname = CONSTS.ALT_DELEGATE_EVENTS[eventname];
      }

      var eClass = CONSTS.EVENT_CLASSES[eventname] || 'CustomEvent';
      var event = null;

      if (utils.is.fn(window[eClass])) {
        event = new window[eClass](eventname, args);
      } else {
        event = document.createEvent(eClass);
        event.initCustomEvent(eventname, args.bubbles, args.cancelable, args.data);
      }

      // add custom data
      event.details = args.details;

      el.dispatchEvent(event);
    });
  }

  this.dom.events = function (el, args, events) {
    if (events === undefined) {
      events = args;
      args = {};
    }

    args = args || {};
    args.context = args.context || null;

    var cache = utils.cache(el, '__EVENTS_BATCH__') || {};
    var hasChanged = false;
    var name, nEvent, oEvent;

    for (name in events) {
      nEvent = events[name];
      oEvent = cache[name];
      cache[name] = nEvent;

      // skip if same
      if (nEvent === oEvent) continue;

      // remove old event
      if (oEvent) {
        removeEvent(el, name, { callback: oEvent, context: args.context });
      }
      // add new one, if set
      if (nEvent) {
        addEvent(el, name, { callback: nEvent, context: args.context });
      }

      hasChanged = true;
    }

    utils.cache(el, '__EVENTS_BATCH__', cache);

    return hasChanged;
  };

  this.dom.events.add = function (el, names, args) {
    addEvent(el, names, args);
  };

  this.dom.events.remove = function (el, names, args) {
    removeEvent(el, names, args);
  };

  this.dom.events.trigger = function (el, names, args) {
    triggerEvent(el, names, args);
  };

  this.dom.events.addCustom = function (name, on, off) {
    CONSTS.CUSTOM_EVENTS[name] = { on: on, off: off };
  };
}).apply(Utils);

export default Utils;
